import { Document } from '@contentful/rich-text-types';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export function hasRichTextContent(document?: Document): boolean {
    if (!document) return false;

    return documentToPlainTextString(document).trim().length > 0;
}
